<template>
  <div class="jgqs-content">
    <v-title :item="sjObj">{{ sjObj.name }}</v-title>
    <!--
    <div class="tab-box flex">
      <div
        v-for="(item, index) in typeList"
        :key="index"
        class="tab-item"
        :class="{ active: active === index }"
        @click="changeType(index)"
      >
        <span>{{ item }}</span>
      </div>
    </div> -->
    <div class="chart" ref="chart" />
  </div>
</template>

<script>
import { loadChart } from "../chart/jgjcData";
import { get } from "@/api/index";
export default {
  data() {
    const year = new Date().getFullYear();
    return {
      sjObj: {
        name: "电商价格趋势(" + year + ")",
        hasBtn: true,
      },
      // typeList: ["收购价", "产地价"],
      // active: 0,
      // chart: null,
      // yearList: ["2020年", "2021年"]
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.chart = this.$echarts.init(this.$refs.chart);
      this.getData();
      window.addEventListener("resize", () => {
        this.chart.resize();
      });
    });
  },
  methods: {
    // changeType(index, name) {
    //   this.active = index;
    //   this.selectName = name;
    //   this.getData();
    // },
    getData() {
      get("/api/restful/getDataPriceDs").then((res) => {
        console.log("res", res);
        if (res) {
          const typeList = ["淘宝", "京东", "拼多多"];
          let tbList = [];
          let jdList = [];
          let pddList = [];
          let bfData = [];
          let xdata = [];
          res.data.forEach((ele) => {
            tbList.push(Number(ele.tb));
            jdList.push(Number(ele.jd));
            pddList.push(Number(ele.pdd));
            xdata.push(ele.date);
          });
          bfData.push(tbList, jdList, pddList);
          loadChart(this.chart, typeList, xdata, bfData, "元/公斤");
        }
      });
    },
    // getData() {
    //   get("/api/restful/cyzl/getMMLZPriceTrend").then(res => {
    //     console.log("new data ===", res);
    //     const data = res.data;
    //     let typeList = [];
    //     let bfData = [];
    //     let firstYear = "";
    //     for (let key in data) {
    //       console.log("key", key);
    //       if (!firstYear) {
    //         firstYear = key;
    //       }
    //       typeList.push(key + "年");
    //       bfData.push(
    //         data[key].map(e => {
    //           return e.price;
    //         })
    //       );
    //     }
    //     console.log("new typeList", typeList);
    //     console.log("new bfData", bfData);
    //     let xdata = data[firstYear].map(e => {
    //       return e.date.replace(/^\d{4}-/, "");
    //     });
    //     console.log("x data ==", xdata);
    //     loadChart(this.chart, typeList, xdata, bfData, "元/公斤");
    //   });
    //   //   get("/api/restful/cyzl/getPriceTrend").then(res => {
    //   //     let data = res.data;
    //   //     let year_17 = [];
    //   //     let year_18 = [];
    //   //     let year_19 = [];
    //   //     let year_20 = [];
    //   //     let year_21 = [];
    //   //     data.theFirstFourYears.map(it => {
    //   //       year_17.push(it.num);
    //   //     });
    //   //     data.theFirstThreeYears.map(e => {
    //   //       year_18.push(e.num);
    //   //     });
    //   //     data.twoYearsBefore.map(e2 => {
    //   //       year_19.push(e2.num);
    //   //     });
    //   //     data.theYearBeforeLasts.map(e3 => {
    //   //       year_20.push(e3.num);
    //   //     });
    //   //     data.thisYears.map(e4 => {
    //   //       year_21.push(e4.num);
    //   //     });
    //   //     this.chart = this.$echarts.init(this.$refs.chart);
    //   //     const yearlist = [
    //   //       "1",
    //   //       "2",
    //   //       "3",
    //   //       "4",
    //   //       "5",
    //   //       "6",
    //   //       "7",
    //   //       "8",
    //   //       "9",
    //   //       "10",
    //   //       "11",
    //   //       "12"
    //   //     ];

    //   //     const resultArr = this.typeList;
    //   //     const bfData = [year_17, year_18, year_19, year_20, year_21];
    //   //     const unit = "元";
    //   //     loadChart(this.chart, resultArr, yearlist, bfData, unit);
    //   //   });
    // }
  },
};
</script>

<style lang="stylus" scoped>
.jgqs-content
    height 100%
    position relative
    .chart
        height calc(100% - 38px)
    .tab-box
        position absolute
        top 40px
        right 2%
        z-index 999
        .tab-item
            color #fff
            font-size 10px
            padding-left 13px
            margin-right 20px
            position relative
            cursor pointer
            &:before
                content ' '
                // width 6px
                // height 6px
                width 12px
                height 12px
                border-radius 50%
                background #fff
                position absolute
                left 0
                top 50%
                transform translateY(-50%)
        .active
            color #0e9cff
            &:before
                background #0e9cff
</style>
